import React, { useMemo } from "react";
import _ from 'lodash';
import cx from 'classnames';

import { CollectionBanner } from "../../types/collections";
import Thumbnail from "../thumbnail";

import styles from './banner.module.scss';

interface BannerViewProps {
  banner: CollectionBanner | undefined;
  defaultBanner?: string;
  width?: number;
  height?: number;
  overlay? : boolean;
}

const BannerView: React.FC<BannerViewProps> = ({ banner, width, height, defaultBanner, overlay = true }) => {
  const background = banner?.background;
  const position = banner?.position;

  return (
    <div className={cx(styles.banner)}>
      <Thumbnail className={styles.background}
        media={background}
        defaultImage={defaultBanner}
        crop={banner?.crop}
        width={width}
        height={height}
        position={position}
      />

      {overlay && <FilterView banner={banner} />}
    </div>
  );
}

const FilterView: React.FC<BannerViewProps> = ({ banner }) => {
  const filter = banner?.filter || banner?.type || 'none';

  const backgroundStyles = useMemo(() => {
    const filter = banner?.filter || banner?.type || 'none';
    const overlayColor = banner?.overlayColor || { r: 0, g: 0, b: 0, a: 0 };

    switch (filter) {
      case 'gradientTop':
        return {
          backgroundImage: `linear-gradient(-24.8312deg, rgba(255,255,255,0), rgba(${overlayColor.r}, ${overlayColor.g}, ${overlayColor.b}, ${overlayColor.a}))`
        }
      case 'gradientBottom':
        return {
          backgroundImage: `linear-gradient(135.862deg, rgba(255,255,255,0), rgba(${overlayColor.r}, ${overlayColor.g}, ${overlayColor.b}, ${overlayColor.a}))`
        }
      case 'lines':
      case 'stripes':
      case 'dots':
        return {
          backgroundColor: `rgba(${overlayColor.r}, ${overlayColor.g}, ${overlayColor.b}, ${overlayColor.a})`,
        }

      default:
        return {
          backgroundColor: '',
          backgroundImage: '',
        }
    }
  }, [banner]);

  if (filter === 'none') {
    return null;
  }

  return (
    <div className={cx(styles.overlay, styles[filter])} style={backgroundStyles} />
  );
}

export { BannerView };